import Loader from "./Loader";
import noUiSlider from "nouislider";
import $ from "jquery";

export default class GetProductsByAttr {
	constructor() {
		this.filter_el = document.getElementsByClassName("jsAttrFilter");
		this.deleteElementsBtn = document.getElementsByClassName("jsDeleteFilter");
		this.attrList = new Map();
		this.activeFilters = [];
		this.selectedSortInput = document.querySelector("#customSortBy");
		this.archiveContainer = document.querySelector(".jsArchiveContainer");
		this.archiveActiveFilters = document.querySelector(".jsActiveFilters");
		this.categoryTitle = document.querySelector(".jsArchiveProductsTitle");
		this.postsModalCounter = document.querySelector(".jsPostsAmountCounter");
		this.priceRangeMinInput = document.querySelector("#rangeMinPrice");
		this.priceRangeMaxInput = document.querySelector("#rangeMaxPrice");
		this.priceRangeMinInputs = document.querySelectorAll(".jsRangeMinPrice");
		this.priceRangeMaxInputs = document.querySelectorAll(".jsRangeMaxPrice");
		this.pageNumber = 1;
		this.sortValue = "";
		this.timeout = null;
		this.allFilters = document.querySelectorAll(".jsDropdownAttrList li");
		this.allFiltersArray = [];

		if (this.allFilters) {
			this.prepareAllFiltersArray();
		}

		this.priceSliderElem = document.querySelector("#rangePriceSlider");
		this.priceMinInput = document.querySelector("#rangeMinPrice");
		this.priceMinInputMobile = document.querySelector(".jsRangeMinPriceMobile");
		this.priceMaxInput = document.querySelector("#rangeMaxPrice");
		this.priceMaxInputMobile = document.querySelector(".jsRangeMaxPriceMobile");

		const th = this;
		if (this.priceSliderElem) {
			this.getPriceMin = this.priceMinInput.valueAsNumber;
			this.getPriceMax = this.priceMaxInput.valueAsNumber;
			th.initializePriceSlider(th.priceSliderElem);
		}

		this.events();
	}

	events() {
		document.addEventListener("click", (e) => {
			if (e.target.classList.contains("jsAttrFilter")) {
				e.preventDefault();
				this.prepareSelectRequest(e.target);
			} else if (e.target.closest(".jsAttrFilter")) {
				e.preventDefault();
				this.prepareSelectRequest(e.target.closest(".jsAttrFilter"));
			} else if (e.target.classList.contains("jsDeleteAllFilters")) {
				e.preventDefault();
				this.deleteAllFiltersRequest();
			} else if (e.target.classList.contains("jsDeleteFilter")) {
				e.preventDefault();
				this.prepareDeleteRequest(e.target);
			} else if (e.target.closest(".jsDeleteFilter")) {
				e.preventDefault();
				this.prepareDeleteRequest(e.target.closest(".jsDeleteFilter"));
			} else if (e.target.classList.contains("jsChangePage")) {
				e.preventDefault();
				this.pageNumber = e.target.dataset.pagenum;
				this.getProductsByAttr(Array.from(this.attrList), this.sortValue);
			} else if (e.target.closest(".jsChangePage")) {
				e.preventDefault();
				this.pageNumber = e.target.closest(".jsChangePage").dataset.pagenum;
				this.getProductsByAttr(Array.from(this.attrList), this.sortValue);
			}
		});

		const th = this;
		if (th.priceSliderElem) {
			th.priceSliderElem.noUiSlider.on("change", (values) => {
				const minUpdatePrice = values[0];
				const maxUpdatePrice = values[1];
				th.priceMinInput.value = minUpdatePrice;
				th.priceMaxInput.value = maxUpdatePrice;

				th.getProductsByAttr(Array.from(th.attrList), th.sortValue);
			});
		}

		th.priceRangeMinInputs.forEach((input) => {
			input.addEventListener("keyup", (e) => {
				th.changeInputPriceTimeout(e, "min");
			});
		});

		th.priceRangeMaxInputs.forEach((input) => {
			input.addEventListener("keyup", (e) => {
				th.changeInputPriceTimeout(e, "max");
			});
		});

		$("#customSortBy").on("change", this.handleSelectChange.bind(this));

		if (this.priceMinInput) {
			this.priceMinInput.onkeydown = function (e) {
				if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || e.keyCode == 8)) {
					return false;
				}
			};
		}

		if (this.priceMinInputMobile) {
			this.priceMinInputMobile.onkeydown = function (e) {
				if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || e.keyCode == 8)) {
					return false;
				}
			};
		}
	}

	handleSelectChange(e) {
		this.getProductsByAttr(Array.from(this.attrList), e.target.value);
	}

	deleteAllFiltersRequest() {
		const flitersBtn = document.querySelectorAll(".jsDeleteFilter");
		const th = this;

		if (this.activeFilters.length) {
			this.activeFilters = [];
			this.attrList = new Map();

			[...flitersBtn].forEach(function (elem) {
				elem.classList.remove("is-active", "jsDeleteFilter");
				elem.classList.add("jsAttrFilter");
			});

			this.getProductsByAttr(Array.from(this.attrList), this.sortValue);
		}

		if (th.priceSliderElem) {
			th.priceSliderElem.noUiSlider.set([th.getPriceMin, th.getPriceMax]);
			th.priceSliderElem.noUiSlider.on("update", () => {
				th.priceMinInput.value = th.getPriceMin;
				th.priceMaxInput.value = th.getPriceMax;

				th.getProductsByAttr(Array.from(th.attrList), th.sortValue);
			});
		}
	}

	prepareSelectRequest(element) {
		const attrName = element.dataset.label;
		const attrKey = element.dataset.key;

		element.classList.remove("jsAttrFilter");

		element.classList.add("is-active", "jsDeleteFilter");

		const mobileAttribute = document.querySelectorAll(
			".sidebar-module__attributes-item[data-label='" + attrName + "'][data-key='" + attrKey + "']"
		);

		if (mobileAttribute) {
			mobileAttribute.forEach((item) => {
				item.classList.remove("jsAttrFilter");
				item.classList.add("is-active", "jsDeleteFilter");
			});
		}

		if (!this.attrList.get(attrKey)) {
			this.attrList.set(attrKey, [attrName]);
		} else {
			if (!this.attrList.get(attrKey).includes(attrName)) {
				this.attrList.get(attrKey).push(attrName);
			}
		}

		if (!this.activeFilters.includes(attrName)) {
			this.activeFilters.push(attrName);
		}
		this.pageNumber = 1;

		this.getProductsByAttr(Array.from(this.attrList), this.sortValue);
	}

	prepareDeleteRequest(element) {
		let deleteFilter = element.dataset.delete;
		const deleteFilterKey = element.dataset.deleteKey;
		this.pageNumber = 1;
		let priceRangeMinInput, priceRangeMaxInput;

		if (this.priceRangeMinInput && this.priceRangeMaxInput) {
			priceRangeMinInput = this.priceRangeMinInput.valueAsNumber;
			priceRangeMaxInput = this.priceRangeMaxInput.valueAsNumber;
		}

		// Remove class on mobile
		const mobileAttribute = document.querySelector(
			".sidebar-module__attributes-item-mobile[data-delete-key='" +
				deleteFilterKey +
				"'][data-delete='" +
				deleteFilter +
				"']"
		);

		if (mobileAttribute) {
			mobileAttribute.classList.add("jsAttrFilter");
			mobileAttribute.classList.remove("is-active", "jsDeleteFilter");
		}

		if (deleteFilterKey == "price_min" || deleteFilterKey == "price_max") {
			if (deleteFilterKey == "price_min") {
				priceRangeMinInput = this.priceMinInput.dataset.defaultValue;

				this.priceSliderElem.noUiSlider.set([this.priceMinInput.dataset.defaultValue, null]);

				this.priceMinInput.value = this.priceMinInput.dataset.defaultValue;

				this.priceMinInputMobile.value = this.priceMinInput.dataset.defaultValue;
			} else if (deleteFilterKey == "price_max") {
				priceRangeMaxInput = this.priceMaxInput.dataset.defaultValue;

				this.priceSliderElem.noUiSlider.set([null, this.priceMaxInput.dataset.defaultValue]);

				this.priceMaxInput.value = this.priceMaxInput.dataset.defaultValue;

				this.priceMaxInputMobile.value = this.priceMaxInput.dataset.defaultValue;
			}

			this.getProductsByAttr(Array.from(this.attrList), this.sortValue, priceRangeMinInput, priceRangeMaxInput);
			return;
		} else if (deleteFilterKey == "custom_filters") {
			const leftAttribute = document.querySelector(
				".sidebar-module__custom-item[data-delete-key='" + deleteFilterKey + "'][data-delete='" + deleteFilter + "']"
			);

			leftAttribute.classList.add("jsAttrFilter");

			leftAttribute.classList.remove("is-active", "jsDeleteFilter");
		} else if (deleteFilterKey === "reviews") {
			const leftAttribute = document.querySelector(
				".sidebar-module__attributes-item[data-delete-key='" +
					deleteFilterKey +
					"'][data-delete='" +
					deleteFilter +
					"']"
			);

			if (leftAttribute) {
				leftAttribute.classList.add("jsAttrFilter");
				leftAttribute.classList.remove("is-active", "jsDeleteFilter");
			}
		} else {
			const leftAttribute = document.querySelectorAll(
				".sidebar-module__attributes-item[data-delete-key='" +
					deleteFilterKey +
					"'][data-delete='" +
					deleteFilter +
					"']"
			);

			if (leftAttribute) {
				leftAttribute.forEach((item) => {
					item.classList.add("jsAttrFilter");
					item.classList.remove("is-active", "jsDeleteFilter");
				});
			}

			deleteFilter = element.dataset.label;
		}

		const deleteElIndex = this.attrList.get(deleteFilterKey).indexOf(deleteFilter);
		const getActiveIndex = this.activeFilters.indexOf(deleteFilter);

		if (this.attrList.get(deleteFilterKey).length > 1) {
			this.attrList.get(deleteFilterKey).splice(deleteElIndex, 1);
		} else {
			this.attrList.delete(deleteFilterKey);
		}
		this.activeFilters.splice(getActiveIndex, 1);

		this.getProductsByAttr(Array.from(this.attrList), this.sortValue);
	}

	getKey(value) {
		return [...this.attrList].find(([key, val]) => val.includes(value))[0];
	}

	getProductsByAttr(attrList, sortBy = "date_desc", priceRangeMinInput = null, priceRangeMaxInput = null) {
		const page = this.pageNumber;
		const searchTerm = new URLSearchParams(window.location.search).get("s") ?? "";
		let defaultPriceRange = [];
		let priceRange = [];
		const localSortBy = document.querySelector("#customSortBy").value ?? sortBy;

		if (this.priceSliderElem) {
			defaultPriceRange = [this.priceRangeMinInput.dataset.defaultValue, this.priceRangeMaxInput.dataset.defaultValue];

			if (priceRangeMinInput !== null && priceRangeMaxInput !== null) {
				priceRange = [priceRangeMinInput, priceRangeMaxInput];
			} else {
				priceRange = [this.priceRangeMinInput.valueAsNumber, this.priceRangeMaxInput.valueAsNumber];
			}
		}

		new Loader(".jsArchiveContainer").enable();

		fetch(window.global.ajax_url + "?action=getProductByAttr", {
			method: "POST", //* GET, POST, PUT, DELETE, etc.
			mode: "cors", // no-cors, *cors, same-origin
			cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
			credentials: "same-origin", // include, *same-origin, omit
			headers: {
				// "Content-Type": "application/json",
				"Content-Type": "application/x-www-form-urlencoded",
			},
			redirect: "follow", // manual, *follow, error
			referrerPolicy: "no-referrer", // no-referrer, *client
			body: new URLSearchParams({
				security: window.global.security,
				attr: JSON.stringify(attrList),
				allFilters: JSON.stringify(this.allFiltersArray),
				prices: JSON.stringify(priceRange),
				active: Array.from(this.activeFilters),
				defaultPrices: JSON.stringify(defaultPriceRange),
				sortBy: localSortBy,
				taxonomy: this.categoryTitle.dataset.catTaxonomy,
				category: this.categoryTitle.dataset.catTitle,
				searchTerm: searchTerm,
				page: page,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					this.archiveContainer.innerHTML = data.data.product_list;
					this.archiveActiveFilters.innerHTML = data.data.active_filters;

					new Loader(".jsArchiveContainer").disable();

					if (this.postsModalCounter) {
						this.postsModalCounter.innerHTML = data.data.product_amount;
					}

					this.changePage();

					window.setTimeout(() => {
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						});
					}, 500);
				}
			});
	}

	changePage() {
		const currentUrl = new URL(window.location.href);
		const queryParams = currentUrl.search;
		currentUrl.pathname = currentUrl.pathname.replace(/page\/[0-9]+/, `page/${this.pageNumber}`);

		if (!currentUrl.pathname.includes("page/")) {
			currentUrl.pathname += `page/${this.pageNumber}`;
		}

		const newUrl = `${currentUrl.pathname}${queryParams}`;

		history.pushState({ page: this.pageNumber }, this.pageNumber, newUrl);
	}

	changeInputsPricesRange(e, type) {
		const th = this;
		if (type == "min") {
			const minValue = e.target.value;
			this.priceSliderElem.noUiSlider.set([minValue, null]);

			this.priceSliderElem.noUiSlider.on("update", () => {
				th.priceRangeMinInputs.forEach((input) => {
					input.value = minValue;
				});
			});
		} else if (type == "max") {
			const maxValue = e.target.value;
			this.priceSliderElem.noUiSlider.set([null, maxValue]);

			this.priceSliderElem.noUiSlider.on("update", () => {
				th.priceRangeMaxInputs.forEach((input) => {
					input.value = maxValue;
				});
			});
		}
		th.getProductsByAttr(Array.from(th.attrList), th.sortValue);
	}

	prepareAllFiltersArray() {
		this.allFilters.forEach((filter) => {
			this.allFiltersArray.push(filter.dataset.key);
		});
	}

	changeInputPriceTimeout(e, type) {
		const th = this;

		if (th.timeout !== undefined) {
			clearTimeout(th.timeout);
		}

		th.timeout = setTimeout(() => {
			th.changeInputsPricesRange(e, type);
		}, 1000);
	}

	initializePriceSlider(slider) {
		noUiSlider.create(slider, {
			start: [this.getPriceMin, this.getPriceMax],
			connect: true,
			step: 5,
			range: {
				min: this.getPriceMin,
				max: this.getPriceMax,
			},
		});
	}
}
